module.exports = __webpack_public_path__ + "static/Arnuv-b3b02375a62e40b905b8ae540d6fdd41.jpg";